import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../environments/environment';
import { Cce } from '../models/Cce';

@Injectable()
export class CceService {

  selectedCodice: string;

  get selected(): string {
    return this.selectedCodice;
  }
  set selected(codice: string) {
    this.selectedCodice = codice;
  }

  constructor(private http: Http) { }

  search(q): Observable<any> {
    return this.http.post(environment.server.url + '/cce/search', { q: q })
      .map(response => response.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cce.service.ts